import { post } from '../helpers/caller'

export const internal = {
  domain: 'internal',
  transactionAchReturn(data: any) {
    return post(internal.domain, internal.transactionAchReturn, data)
  },
}
